// Module
var code = " <footer class=\"actions\" layout layout-align=\"end center\" flex> <md-button ng-click=\"::$ctrl.onSave({ e: $event })\" class=\"save\"> <md-icon>check_circle</md-icon> <strong>Save Changes</strong> </md-button> </footer> ";
// Exports
module.exports = code;